export default __webpack_public_path__ + "af96698e6248b5be6d9146b6414e7e91.woff2";